import{useContext as o}from"react";import t from"./Context.js";var r=()=>{const r=o(t);if(!r)throw Error("You can only use this hook in the context of <AuthProvider />");return r};export{r as default};
//# sourceMappingURL=useContext.js.map
